import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-price-list-bus-cos',
  templateUrl: './price-list-bus-cos.component.html',
  styleUrls: ['./price-list-bus-cos.component.css']
})
export class PriceListBusCosComponent implements OnInit {
    priceListId;

    public itemsListBusinessCompanies: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.priceListId = this.stateService.getStateParams()['pricelist_id'];
    }

    private async loadBusinessCompanies() {
        if (!this.priceListId) return;

        this.itemsListBusinessCompanies = await this.datatask.Post(666, { pricelist_id: this.priceListId });
    }

    private async init() {
        this.loadBusinessCompanies();
    }

    ngOnInit() {
        this.init();
    }
}
